import AsyncStorage from '@react-native-async-storage/async-storage';
import { clientConfigPath } from '../../config/Constant';
import { getHotelLangFailure, getHotelLangSuccess, initHotelLangRequest } from '../Reducers/hotelLangReducer';



export const getHotelLang = () => {


  return async dispatch => {
    dispatch(initHotelLangRequest());

    try {
      const DeviceIdentifier = await AsyncStorage.getItem('DeviceIdentifier');

      let room = await AsyncStorage.getItem('room');
      let rn = room || 'notLogin';

      clientConfigPath.get(`/hotelLanguage/fetch-all?dId=${DeviceIdentifier}&rn=${rn}`)
        .then(response => {
          console.log('HotelLang-action------>', response.data);
          dispatch(getHotelLangSuccess(response.data?.payload));
        })
        .catch(error => {
          console.log('HotelLang-action------>', error.message);
          dispatch(getHotelLangFailure(error.message));
        });
    } catch (error) {
      console.error('Error fetching data from AsyncStorage', error);
      dispatch(getHotelLangFailure(error.message));
    }
  };
};
